import dayjs from "dayjs";

const resolveRelationId = (value) => {
    if (value && typeof value === "object") {
        return value.id ?? null;
    }

    if (typeof value === "number") {
        return value;
    }

    return null;
};

const arrivalConverter = {
    convertIn: (responseData) => {
        if (responseData.orderDate) {
            responseData.orderDate = dayjs(responseData.orderDate);
        }

        if (responseData.deliveryDate) {
            responseData.deliveryDate = dayjs(responseData.deliveryDate);
        }

        if (responseData.createdAt) {
            responseData.createdAt = dayjs(responseData.createdAt);
        }

        if (responseData.updatedAt) {
            responseData.updatedAt = dayjs(responseData.updatedAt);
        }

        return responseData;
    },
    convertOut: ({ product, supplier, ...rest }) => {
        const productId = resolveRelationId(product);
        const supplierId = resolveRelationId(supplier);

        return {
            ...rest,
            ...(productId && {
                product: productId,
            }),
            ...(supplierId && {
                supplier: supplierId,
            }),
        };
    },
};

export default arrivalConverter;
